import { FileText, Mail, MoreVertical, Pause, Play, Settings, Trash2 } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './RowActions.css';

const RowActions = ({ tenant, onActivate, onSuspend, onResume, onDelete, onLegalDocuments }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [isMenuOpen]);

    const handleMenuToggle = (e) => {
        e.stopPropagation();
        setIsMenuOpen(!isMenuOpen);
    };

    const handleAction = (action) => {
        setIsMenuOpen(false);
        action();
    };

    const isActive = tenant.status === 'ACTIVE';
    const isPending = tenant.status === 'CONTRACT_SIGNED_PENDING_ACTIVATION' || tenant.status === 'CONTRACT_SIGNED_PENDING_PAYMENT';
    const isSuspended = tenant.status === 'SUSPENDED';

    return (
        <div className="row-actions">
            {/* Primary Action */}
            <Link
                to={`/admin/tenant/${tenant.id}`}
                className="btn-action btn-primary btn-icon-only"
                title="Gestisci tenant"
                aria-label="Gestisci tenant"
                data-tooltip="Gestisci tenant"
            >
                <Settings size={16} />
            </Link>

            {/* Secondary Actions Menu */}
            <div className="action-menu" ref={menuRef}>
                <button
                    className="btn-action btn-menu"
                    onClick={handleMenuToggle}
                    title="Altre azioni"
                >
                    <MoreVertical size={16} />
                </button>

                {isMenuOpen && (
                    <div className="action-dropdown">
                        {isPending && (
                            <button
                                className="action-item action-activate"
                                onClick={() => handleAction(onActivate)}
                            >
                                <Play size={16} />
                                <span>Attiva Tenant</span>
                            </button>
                        )}

                        {isActive && (
                            <button
                                className="action-item action-suspend"
                                onClick={() => handleAction(onSuspend)}
                            >
                                <Pause size={16} />
                                <span>Sospendi</span>
                            </button>
                        )}

                        {isSuspended && (
                            <button
                                className="action-item action-resume"
                                onClick={() => handleAction(onResume)}
                            >
                                <Play size={16} />
                                <span>Riattiva</span>
                            </button>
                        )}

                        {!isActive && (
                            <button
                                className="action-item action-resend"
                                onClick={() => handleAction(() => alert('Funzionalità reinvia invito in sviluppo'))}
                            >
                                <Mail size={16} />
                                <span>Reinvia Invito</span>
                            </button>
                        )}

                        <button
                            className="action-item action-legal"
                            onClick={() => handleAction(onLegalDocuments)}
                        >
                            <FileText size={16} />
                            <span>Legal documents</span>
                        </button>

                        <div className="action-divider"></div>

                        <button
                            className="action-item action-delete"
                            onClick={() => handleAction(onDelete)}
                        >
                            <Trash2 size={16} />
                            <span>Elimina Tenant</span>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RowActions;
